import { AuthState } from "../Interface/interface";
import { createSlice } from "@reduxjs/toolkit";
import {
  createUserAction,
  fetchPatnerUserList,
  fetchUserList,
  getPartnerProfile,
  getUserProfile,
  postEditProfile,
  postForget,
  postLogin,
  postresetpassword,
  resendInvite,
  updateUserGuide,
  validateUniqueCode,
} from "./action";

const initialState = {
  token: "",
  userDetail: {},
  messageofToaster: "",
  typeofToaster: "",
  userList: [],
  partnerUserList: {},
  selectedProduct: [],
  partnerDetail: {},
  userPermissions: [],
  selectedUsers: "",
  updatedProducts: [],
  selectedChildProduct: [],
  updatedChildProduct: [],
  otherSubProduct: [],
  selectedAddons: [],
  updatedAddons: [],
  allChildCombination: [],
  CalCombination: [],
  globalUpdate: false,
  isFederalGlobalUser: false
} as unknown as AuthState;

const authSlice: any = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogoutRedux: (state) => {
      state.token = "";
      state.userDetail = {};
    },
    handleError: (state) => {
      state.typeofToaster = "";
      state.messageofToaster = "";
    },
    handleProduct: (state, action) => {
      state.selectedProduct = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleChildProduct: (state, action) => {
      state.selectedChildProduct = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleSelectAddons: (state, action) => {
      state.selectedAddons = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleUpdatedAddons: (state, action) => {
      state.updatedAddons = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleBusinessUser: (state, action) => {
      state.selectedProduct = [];
      state.updatedProducts = [];
      state.selectedUsers = action.payload;
    },
    handleGlobalBusinessUser:(state,action)=>{ 
      state.isFederalGlobalUser = action.payload == 1
    } ,
    handleUpdatedChildProduct: (state, action) => {
      state.updatedChildProduct = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleOtherSubProduct: (state, action) => {
      state.otherSubProduct = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleAllCombination: (state, action) => {
      state.allChildCombination = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handlCalCombination: (state, action) => {
      state.CalCombination = JSON.parse(JSON.stringify(action.payload))?.sort();
    },
    handleUpdatedProduct: (state, action) => {
      if (action.payload?.length > 0) {
        state.updatedProducts = [...new Set(JSON.parse(JSON.stringify(action.payload))?.sort())];
        // state.selectedProduct.filter
        // state.selectedProduct = [...new Set([...state.selectedProduct, ...state?.updatedProducts ?? []])].sort();
      } else {
        state.updatedProducts = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      ?.addCase(postLogin?.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.token = payload ? payload.data?.authToken : "";
          state.userDetail = payload ? payload.data?.userInfo : {};
          state.userPermissions = payload ? payload.data?.userPermissions : [];
          state.isFederalGlobalUser = payload && [7, 8, 9].includes(payload?.data?.userInfo?.roleId)
        }
      })
      .addCase(postForget.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "success";
        }
      })
      .addCase(postresetpassword.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "success";
        }
      })
      .addCase(postEditProfile.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "success";
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(updateUserGuide.fulfilled, (state, { payload }: any) => {
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(validateUniqueCode.fulfilled, (state, { payload }: any) => {
        if (payload.status === 422) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "error";
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(getUserProfile.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.userDetail = payload.data.data;
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(createUserAction.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "success";
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(resendInvite.fulfilled, (state, { payload }: any) => {
        if (payload.status === 200) {
          state.messageofToaster = payload.data.message;
          state.typeofToaster = "success";
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(fetchUserList.fulfilled, (state, { payload }: any) => {
        if (payload && payload.status === 200) {
          state.userList = payload.data.data;
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(fetchPatnerUserList.fulfilled, (state, { payload }: any) => {
        if (payload && payload.status === 200) {
          state.partnerUserList = payload.data.data;
        }
        if (payload.status === 401) {
          state.token = "";
        }
      })
      .addCase(getPartnerProfile.fulfilled, (state, { payload }: any) => {
        if (payload && payload.status === 200) {
          state.partnerDetail = payload.data.data;
        }
        if (payload.status === 401) {
          state.token = "";
        }
      });
  },
});

export const { handleLogoutRedux, handleError, handleProduct, handleBusinessUser, handleUpdatedProduct, handleChildProduct, handleUpdatedChildProduct, handleOtherSubProduct, handleSelectAddons, handleAllCombination, handleUpdatedAddons, handlCalCombination, handleGlobalBusinessUser } =
  authSlice.actions;

export default authSlice.reducer;
